import ReactJoyride from "react-joyride";
import CustomTooltip from "./CustomTooltip";
import React from "react";

export default function TourMain() {
  const steps = [
    {
      target: ".tour-dashboard",
      content: `The Dashboard will show a performance overview of your Council.
         This includes data on tickets, events, deals and others.`,
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-posts",
      content:
        "Create a Post here to update and communicate with your community. You can also manage and edit your posts to keep them up to date.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-events",
      content: `The Events page allows you to create free or paid events for your community to attend. 
        Here you could also manage and edit your published events to ensure they are updated.`,
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-users",
      content:
        "View and manage the people within you council. You can also add and remove members accordingly.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-attraction",
      content:
        "The Attractions page allows you to create and manage attractions within you council.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-council-profile",
      content: `View, manage and make changes to your council profile. 
        Here you can edit the details of your council as well as view and moderate all existing content.`,
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-settings",
      content:
        "Customize your notifications, accessibility settings and view your terms and conditions.",
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-add",
      content: `Use this to quickly add a new post, 
        event or attraction for your customers.`,
      disableBeacon: true,
      placement: "right-start",
    },
    {
      target: ".tour-add",
      content: `Use this to quickly add a new post, 
        event or attraction for your customers.`,
      disableBeacon: true,
      placement: "right-start",
    },
  ];

  return (
    <ReactJoyride
      steps={steps}
      run={true}
      continuous={true}
      spotlightPadding={0}
      disableScrolling={true}
      hideCloseButton={true}
      tooltipComponent={CustomTooltip}
    />
  );
}
